import { Typography } from "@material-ui/core";
import { RouteRequestParameters } from "api/lokiRequestModels/RouteRequestParameters";
import clsx from "clsx";
import AdvancedFilters from "components/AdvancedFilters/AdvancedFilters";
import { dateEndFormatting, dateStartFormatting } from "helpers/dateFormatting";
import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useStore } from "store/StoreConfigs";
import { RouteViewShipmentsTableWrapper } from "./RouteViewShipmentsTableWrapper";
import { routeViewStyles } from "./RouteViewStyles";

export const RouteView = observer(function RouteView() {
    const classes = routeViewStyles();

    const { commonStore, filtersStore, routeViewStore, identityStore } = useStore();

    const [isFiltersReset, setResetFilters] = useState(false);

    const { routeId } = useParams<any>();

    const shipmentsRequest: RouteRequestParameters = {
        startTime: dateStartFormatting(filtersStore.startDate),
        endTime: dateEndFormatting(filtersStore.endDate),
        customerId: identityStore.currentCustomerId,
        routeId,
        lsp: filtersStore.selectedLogisticsServiceProviders.join(",") || undefined,
        productType: filtersStore.selectedProductTypes.join(",") || undefined,
        riskLevel: filtersStore.selectRiskLevels.join(",") || undefined,
        transportationModes: filtersStore.selectedModesOfTransportation.join(",") || undefined,
        packagingType: filtersStore.selectedPackagingTypes.join(",") || undefined,
        sort: routeViewStore.sortShipment,
        direction: routeViewStore.directionShipment,
    };

    const callbackRequest = () => {
        if (filtersStore.startDate === null || filtersStore.endDate === null) {
            return;
        }

        commonStore.setFiltersClose();
    };

    const AdvancedFiltersRequest = () => {
        if (filtersStore.startDate === null || filtersStore.endDate === null) {
            return;
        }

        routeViewStore.loadFirstShipmentsPage(shipmentsRequest);
        commonStore.setFiltersClose();
    };

    useEffect(() => {
        isFiltersReset ? setResetFilters(true) : filtersStore.resetFilters();

        callbackRequest();
        window.scrollTo(0, 0);
    }, [filtersStore.startDate, filtersStore.endDate]);

    useEffect(() => {
        if (filtersStore.startDate === null || filtersStore.endDate === null) {
            return;
        }

        routeViewStore.loadFirstShipmentsPage(shipmentsRequest);
        commonStore.setFiltersClose();
    }, [routeViewStore.directionShipment, routeViewStore.sortShipment, filtersStore.startDate, filtersStore.endDate]);

    useEffect(() => {
        commonStore.setCurrentView("route");
    }, []);

    return (
        <>
            <AdvancedFilters requestCallback={AdvancedFiltersRequest} />

            <div
                className={clsx({
                    [classes.dis]: commonStore.isFilterOpen,
                })}
            ></div>

            <main className={classes.content}>
                <div className={classes.toolbar} />

                <Typography variant="h4" component="h2" className={classes.tableTitle}>
                    Shipments
                </Typography>
                <Typography variant="body1" className={classes.tableSubtitle}>
                    Survey the latest lane risk level changes.
                </Typography>

                <RouteViewShipmentsTableWrapper />
            </main>
        </>
    );
});
